// extracted by mini-css-extract-plugin
module.exports = {"volume":"_1-Yq0T","checkmark":"_2QpFWx","active":"_38GB1C","black":"_1HfcbT","missingColor":"_3BmpoO","volumeContainer":"_3FMtjW","shine-lines":"_32xgeL"};